import React from 'react'
import { Link } from 'react-router-dom'


export default function NotFound() {
  return (
    <div>
      <h2>Page not found!</h2>
      <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolore ut debitis repudiandae autem velit vero!</p>
      

      <p><Link to="/">Homepage</Link></p>
    </div>
  )
}
